import { render, staticRenderFns } from "./SchemaIOWindow.vue?vue&type=template&id=6e14ff8b&"
import script from "./SchemaIOWindow.vue?vue&type=script&lang=js&"
export * from "./SchemaIOWindow.vue?vue&type=script&lang=js&"
import style0 from "./SchemaIOWindow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports